var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLocalStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 79.792 78.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16746",
    "data-name": "Group 16746",
    transform: "translate(-144 -2035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32475",
    "data-name": "Path 32475",
    d: "M33.276,2A18.276,18.276,0,1,0,51.551,20.276,18.276,18.276,0,0,0,33.276,2Z",
    transform: "translate(129 2033)",
    fill: "#ffdcbb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16745",
    "data-name": "Group 16745",
    transform: "translate(155.49 2044.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32476",
    "data-name": "Path 32476",
    d: "M70.9,67.422,63.94,60.457A7.159,7.159,0,0,1,61.7,55.233V18.915a6.775,6.775,0,0,0-2.239-5.224L50.009,4.239A7.159,7.159,0,0,0,44.786,2H19.413a2.35,2.35,0,0,0-2.488,2.488,2.35,2.35,0,0,0,2.488,2.488H44.786a2.258,2.258,0,0,1,1.741.746l9.453,9.453a2.687,2.687,0,0,1,.746,1.741V53.243L13.194,9.711,6.229,2.746a2.4,2.4,0,0,0-3.483,0,2.4,2.4,0,0,0,0,3.483l6.965,6.965a7.717,7.717,0,0,1,2.239,5.473V64.188a7.329,7.329,0,0,0,7.463,7.463H54.238a2.488,2.488,0,0,0,0-4.975H19.413a2.35,2.35,0,0,1-2.488-2.488V20.408L33.343,36.825h-3.98A7.329,7.329,0,0,0,21.9,44.288v9.95A7.329,7.329,0,0,0,29.363,61.7H44.288a7.509,7.509,0,0,0,7.463-6.468L67.422,70.9A2.463,2.463,0,0,0,70.9,67.422ZM46.776,54.238a2.35,2.35,0,0,1-2.488,2.488H29.363a2.35,2.35,0,0,1-2.488-2.488v-9.95A2.35,2.35,0,0,1,29.363,41.8h8.955l8.458,8.458Z",
    transform: "translate(-3.35 -2)",
    fill: "#2a3d57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocalStorage);
export default __webpack_public_path__ + "static/media/NoLocalStorage.3f0c7c3ab2ae1a69c8caf6ad9b339b38.svg";
export { ForwardRef as ReactComponent };